var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNounFeather3136951(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 218.85,
    height: 74.78,
    viewBox: "0 0 218.85 74.78",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0,31.44s25.3,9.32,68.37,11.11c43.06,1.79,113.69-6.46,113.69-6.46,0,0-49.65,16.9-136.57,8.91,0,0-.38,9.22-4.43,13.43,0,0,4.19-1.77,7-5.3,0,0,.11,9-2.3,14.49,0,0,4.88-2.03,5.19-14.13,0,0,5.43,9.46,11.26,14.81,0,0-2.62-6.92-2.93-11.31,0,0,15.93,19.14,33.93,17.7,0,0-13.03-7.35-15.42-14.01,0,0,10.65,6.28,16.65,7.74,6,1.46,22.66,2.89,55.77-.6,33.1-3.49,68.06-34.13,68.63-42.13.57-8-31.48-24.16-41.36-25.54-9.88-1.38-35.64,6.3-48.52,18.65,0,0,13.2-14.52,23.54-18.47,0,0-44.42-4.28-70.87,25.99,0,0,10.1-15.63,18.36-22.09,0,0-18.36,4.59-28.57,16.8,0,0,1.29-7.73,3.12-11.05,0,0-6.62,1.91-11.78,9.48,0,0,3.24-8.13,5.54-10.95,0,0-10.9,5.63-16.26,18.29,0,0,1.56-8.44-3.74-15.23,0,0,.58,9.5-1.07,14.06,0,0-2.03-3.73-2.57-8.13,0,0-2.01,7.56,1.03,16.26,0,0-5.21-3.06-7.47-6.81,0,0,.74,5.62,4.97,8.71,0,0-15.25-.39-27.45-4.3-12.2-3.91-15.75.07-15.76.07h0Z",
    fill: "#fff",
    strokeWidth: 0
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNounFeather3136951);
export default __webpack_public_path__ + "static/media/noun-feather-3136951.71ac2042475ad13debfc4b971537e1b1.svg";
export { ForwardRef as ReactComponent };